import { render, staticRenderFns } from "./PropertyOccupants.vue?vue&type=template&id=2bacb63c"
import script from "./PropertyOccupants.vue?vue&type=script&lang=js"
export * from "./PropertyOccupants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports